import { useEffect, useRef } from 'react';

export function useIOSAudioUnlock(audioRef) {
  const unlocked = useRef(false);
  useEffect(() => {
    const unlock = async () => {
      if (unlocked.current) return;
      const audio = audioRef.current;
      if (!audio) return;
      try {
        // Buffer silencieux 1 sample pour unlock iOS Safari
        audio.muted = true;
        await audio.play();
        audio.pause();
        audio.muted = false;
        audio.currentTime = 0;
        unlocked.current = true;
      } catch (e) {
        /* will retry on next gesture */
      }
    };
    document.addEventListener('touchstart', unlock, {
      once: true,
      passive: true,
    });
    document.addEventListener('click', unlock, { once: true });
    return () => {
      document.removeEventListener('touchstart', unlock);
      document.removeEventListener('click', unlock);
    };
  }, [audioRef]);
}
